import { FC, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom';

import { Team } from '@/types';

import { Members, Settings } from './routes';

interface ContentProps {
    team: Team;
}

const Content: FC<ContentProps> = ({ team }): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { teamId } = useParams<{ teamId: string }>();
    const url = `/settings/workspace/permissions/teams/${teamId ?? team.id}`;

    const location = useLocation();

    return (
        <div style={{ padding: '0.5rem 0' }}>
            <Routes location={location}>
                <Route index element={<Navigate to={`${url}/members`} replace />} />
                <Route path='members' element={<Members team={team} />} />
                <Route path='settings' element={<Settings team={team} />} />
            </Routes>
        </div>
    );
};

export default Content;
